import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../../../services/interfaces';
import { isEmpty } from '../../../../../services/utils';
import {
  isCanceledMatch,
  isLiveMatch,
  isLiveMatchPenalties,
  isPostponedMatch,
  isSuspendedMatch,
  isUpcomingMatch,
  isVerticalLayout,
  setCssVariant,
} from '../../helpers';
import { MatchDate } from '../match-date/match-date';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchScore = ({ state }: Props): Promise<HTMLDivElement> => {
  const size = state.size;
  const cssVariant = setCssVariant(size);
  const isVertical = isVerticalLayout(size);

  const match = state.matchData;
  if (!match) return null;

  const hasRedCards = state.showRedCards && !isEmpty(match.playerEvents?.redCards);

  const matchStatus = match.status;
  const upcomingMatch = isUpcomingMatch(matchStatus);
  const liveMatch = isLiveMatch(matchStatus);
  const livePenalties = isLiveMatchPenalties(matchStatus, match.phase);
  const suspendedMatch = isSuspendedMatch(matchStatus);
  const canceledMatch = isCanceledMatch(matchStatus);
  const postponedMatch = isPostponedMatch(matchStatus);

  const disabledScore: boolean = canceledMatch || postponedMatch;

  const scorePlaceholder = isVertical ? '-' : '';

  return (
    <div class={{ 'pk-match__score': true, 'has-redcards': hasRedCards, ...cssVariant }} part="match-score">
      {!isVertical && upcomingMatch && <MatchDate state={state} />}
      <div
        class={{
          'pk-match__score--goals': true,
          hidden: upcomingMatch,
          live: liveMatch,
          'live-penalties': livePenalties,
          suspended: suspendedMatch,
          disabled: disabledScore,
          ...cssVariant,
        }}
        part="match-score-goals"
      >
        <span class="home-score" part="home-score">
          {!disabledScore ? (match?.score?.total?.home ?? '0') : scorePlaceholder}
        </span>
        {!isVertical && '-'}
        <span class="away-score" part="away-score">
          {!disabledScore ? (match?.score?.total?.away ?? '0') : scorePlaceholder}
        </span>
      </div>
    </div>
  );
};

export { MatchScore };
